import { parse as cookieParse, serialize as cookieSerialize } from 'cookie';
import { strollers_api_v2_get_stroller_product_photos_url } from 'mk/urls/functions';
import {
    strollerProductPhotoFetchApi,
    strollerProductPhotoUpdateThumbs,
    StrollerProductPhotoCheckHideThumbsAction,
    StrollerProductPhotoFetchNormalizedResponse,
    StrollerProductPhotoFetchTriggerAction,
    StrollerProductPhotoToggleThumbsTriggerAction,
    STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS,
    STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER,
    STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER,
} from 'mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhoto.actions';
import {
    STROLLER_PRODUCT_PHOTO_HIDE_THUMBNAILS_COOKIE,
} from 'mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/StrollerProductPhoto.sagas');

const getStrollerPhotosHideThumbnailsCookie = (): boolean => {
    if (typeof window !== 'undefined') {
        return cookieParse(document.cookie)[STROLLER_PRODUCT_PHOTO_HIDE_THUMBNAILS_COOKIE] === String(true) || false;
    }
    return false;
};

interface FetchApiResponse {
    body: StrollerProductPhotoFetchNormalizedResponse;
}

function* fetchStrollerReviews({ strollerSlug, strollerVariantId, xhr }: StrollerProductPhotoFetchTriggerAction & XHRAction) {
    yield put(strollerProductPhotoFetchApi.request(strollerSlug));

    try {
        const response: FetchApiResponse = yield call(
            () => xhr.get(strollers_api_v2_get_stroller_product_photos_url({strollerSlug, strollerVariantId})),
        );

        yield put(strollerProductPhotoFetchApi.success(strollerSlug, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(strollerProductPhotoFetchApi.failure(strollerSlug, normalizeError(error)));
    }
}

function* toggleThumbs({ xhr }: StrollerProductPhotoToggleThumbsTriggerAction & XHRAction) {
    const currentValue = getStrollerPhotosHideThumbnailsCookie();

    // when changing showThumbnails then the ImageGalleryLoadable need to be unmounted and re-rendered (to avoid buggy
    // behaviour of showThumbnail) */}
    yield put(strollerProductPhotoUpdateThumbs(null));
    yield delay(500);

    const newValue = !currentValue;
    document.cookie = cookieSerialize(STROLLER_PRODUCT_PHOTO_HIDE_THUMBNAILS_COOKIE, String(newValue), {
        path: '/',
    });
    yield put(strollerProductPhotoUpdateThumbs(newValue));
}

function* checkHideThumbs({ xhr }: StrollerProductPhotoCheckHideThumbsAction & XHRAction) {
    const currentValue = getStrollerPhotosHideThumbnailsCookie();
    yield put(strollerProductPhotoUpdateThumbs(currentValue));
}

export default function* root() {
    yield all([
        takeLatest(STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER, fetchStrollerReviews),
        takeLatest(STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER, toggleThumbs),
        takeLatest(STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS, checkHideThumbs),
    ]);
}
